import { useEffect, useState } from 'react'

import { errorText } from '../i18n'
import { parseStartParam, targetFromLocation, type StartTarget } from '../lib/startParam'
import { ready, webApp } from '../lib/telegram'
import { WatchPage } from '../pages/watch'

/**
 * 应用装配。
 *
 * 一期只有一个页面，所以**不引入路由库** —— 目标完全由启动参数决定。
 * 目标只来自启动参数，**页面内没有任何通往别的剧的入口**：一剧一页，
 * 进来看哪一部由链接决定。
 */
export function App() {
  const [target] = useState<StartTarget | null>(() => {
    const fromTelegram = parseStartParam(webApp()?.initDataUnsafe?.start_param)
    return fromTelegram ?? targetFromLocation()
  })

  useEffect(() => {
    ready()
  }, [])

  // 没有启动参数说明链接不完整（例如有人直接打开域名根路径）
  if (!target) {
    return (
      <main style={styles.center}>
        <p>{errorText('not_found')}</p>
      </main>
    )
  }

  return <WatchPage target={target} />
}

const styles = {
  center: {
    minHeight: '100dvh',
    display: 'grid',
    placeItems: 'center',
    padding: 24,
    textAlign: 'center',
  },
} satisfies Record<string, React.CSSProperties>
